// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3371138e","453":"e37ffee3","455":"22b8e635","977":"3e3ab6eb"}[chunkId] + ".chunk.js";
};